import PropTypes from "prop-types";
import { useEffect, useState } from "react";

import useSelecaoAmparoLegal, { SelecaoAmparoLegalRender } from "../../components/SelecaoAmparoLegal";
import ModalSeplag from "../../components/ModalSeplag";
import { validarBeneficiario } from "../../service/EventoCertidao/validarBeneficiario"
import CertidaoView from './certidaoView'

import { buscarPorCodigo } from "../../service/certidao";

const ModalValidarBeneficiario = (props) => {
    // const {justificativasSelecionada, SelecaoAmparoLegalRender} = SelecaoAmparoLegal(props)    
    const amparo = useSelecaoAmparoLegal()
    const [certidao, setCertidao] = useState(null);

    let isFlagValidaBeneficiario = props.certidaoSelected && props.certidaoSelected.flagValidacaoBeneficiario == "S"

    useEffect(() => {

        buscarPorCodigo(props.certidaoSelected.idenCertidao).then(res => {
            setCertidao(res)
        })

    }, []);

    const handleSalvar = (dados) => {
        let amparoLegalSelecionado = amparo.justificativasSelecionada
        let data = new Date()

        let jsonBody = {
            idenCertidao: props.certidaoSelected.idenCertidao,
            dataEventoCertidao: `${data.toLocaleDateString('pt-BR')}`,
            siglaTipoEventoCertidao: 'VAL_BENEF',
            listaAmparoLegalCertidao: amparoLegalSelecionado,
        }

        validarBeneficiario(jsonBody).then(res => {
            window.$toast.current.show({ severity: 'success', summary: res.data });
            props.onSalvar && props.onSalvar()
            props.onFechar()
        })

    }


    if (!certidao) {
        return <> </>
    }
    return (
        <ModalSeplag
            titulo={'Validar Beneficiário'}
            visible={props.visible}
            fechar={props.onFechar}
            funcAcao={handleSalvar}
            tamanho="70em"
            labelAcao={props.tipoAcao}
            type={isFlagValidaBeneficiario && 'CLOSE'}
        >

            <>
                <CertidaoView certidao={certidao} />
                <div className="p-col-12" />
                {!isFlagValidaBeneficiario && <SelecaoAmparoLegalRender {...amparo} disabled={isFlagValidaBeneficiario} />}
            </>

        </ModalSeplag>
    );

};

ModalValidarBeneficiario.propTypes = {
    visible: PropTypes.bool.isRequired,
    onFechar: PropTypes.func.isRequired,
    onSalvar: PropTypes.func,
};

export default ModalValidarBeneficiario;